import { Injectable } from '@angular/core';
@Injectable()
export class WindowWrapper extends Window {
}